export interface Translation {
    [locale: string]: string;
}
